module.exports = __webpack_public_path__ + "img/cloudicon.1abe670d.svg";